module.exports = __webpack_public_path__ + "img/43_13.63ad2f9f.png";